import { Box, createStyles, Text, Title } from '@mantine/core';
import { TFunction } from 'i18next';

const useStyles = createStyles((theme) => {
  return {
    title: {
      color: theme.colors['headings-and-links'][0],
      margin: '30px 0',
    },
    desc: {
      color: theme.colors['body-text'][0],
      maxWidth: '100%',

      img: {
        maxWidth: '100%',
        height: 'auto',
      },
    },
  };
});

type Props = {
  isMobile: boolean;
  desc: string;
  useShopAsCatalogue: boolean;
  t: TFunction;
};

const ProductDesc = ({ isMobile, desc, useShopAsCatalogue, t }: Props) => {
  const { classes } = useStyles();

  return (
    <Box maw="100%">
      <Title className={classes.title} order={isMobile ? 3 : 2}>
        {useShopAsCatalogue ? t('desc') : t('product-details')}
      </Title>
      <Text className={classes.desc} dangerouslySetInnerHTML={{ __html: desc }} />
    </Box>
  );
};

export default ProductDesc;
